import { render, staticRenderFns } from "./card.vue?vue&type=template&id=32af7512&scoped=true"
import script from "./card.vue?vue&type=script&lang=ts"
export * from "./card.vue?vue&type=script&lang=ts"
import style0 from "./card.vue?vue&type=style&index=0&id=32af7512&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af7512",
  null
  
)

export default component.exports